import * as React from "react";

function SvgBuilding(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      {...props}
    >
      <g
        stroke="currentColor"
        strokeWidth={1.667}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14.167 39.167h25V.833h-25zm-13.334 0h13.334V10.833H.833z" />
        <path d="M5.833 20.833h8.334v-5H5.833zm0 10h8.334v-5H5.833zM30.833 39.167H22.5v-5a3.335 3.335 0 013.333-3.334H27.5a3.335 3.335 0 013.333 3.334v5zM19.166 5.833h1.667m5 0H27.5m5 0h1.666m-15 5h1.667m5 0H27.5m5 0h1.666m-15 5h1.667m5 0H27.5m5 0h1.666m-15 5h1.667m5 0H27.5m5 0h1.666m-15 5h1.667m5 0H27.5m5 0h1.666" />
      </g>
    </svg>
  );
}

export default SvgBuilding;
